import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import {
    makeSelectSuggestionsEndpoint,
    makeSelectDictionary
} from 'data/config/runtime-config-selectors';
import SearchComponent from './search-component';

const mapStateToProps = createStructuredSelector({
    suggestionsEndpoint: makeSelectSuggestionsEndpoint(),
    dictionary: makeSelectDictionary(),
});

export default connect(mapStateToProps)(withRouter(SearchComponent));
